@if (page$ | async; as page) {
  <div class="main">
    @if (filter$ | async; as filter) {
      <div class="filter-toolbar" fxLayout="row" fxLayoutGap="2rem">
          <redispatch-erzeugungsanlage-filter fxLayout="column" fxFlex="75 1 0"
            [initialFilter]="filter"
            (filter)="filterChanged($event)"
          ></redispatch-erzeugungsanlage-filter>
          @if (resolvedErzeugungsanlagenPage) {
            <mat-card class="mat-card-custom" data-qa="erzeugungsanlagen-total-infos" fxLayout="column"
              fxFlex="auto 0 0"
              >
              <mat-card-content fxLayout="row wrap" fxLayoutGap="1rem" >
                <div fxLayout="column" fxLayoutGap="1rem">
                  <mat-label>
                    <mat-icon class="svg-icon" svgIcon="electricity"></mat-icon>
                    <span
                    class="resolved-value">&nbsp;{{ resolvedErzeugungsanlagenPage.totalNumberOfEa }}</span>
                    <span class="label-info">&nbsp;Gesamtanzahl Erzeugungsanlagen</span>
                  </mat-label>
                  <mat-label>
                    <mat-icon class="svg-icon" svgIcon="consumption"></mat-icon>
                    <span
                    class="resolved-value">&nbsp;{{ resolvedErzeugungsanlagenPage.sumBruttonennleistung | leistungseinheit:Leistungseinheit.MW }}</span>
                    <span class="label-info">&nbsp;Bruttonennleistung (&#8721;)</span>
                  </mat-label>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
      <div fxLayout="column" fxLayoutGap="2rem">
          @if (resolvedErzeugungsanlagenPage; as erzeugungsanlagenPage) {
            <div data-qa="erzeugungsanlage-result">
              <redispatch-erzeugungsanlage-table
                [erzeugungsanlagen]="erzeugungsanlagenPage.content"
                [netzbetreiberType]="profile.netzbetreiberType"
                [sortActive]="page.sort"
                [sortDirection]="page.direction"
                (sortChange)="sortChange($event)"
                >
              </redispatch-erzeugungsanlage-table>
              <mat-paginator #paginator
                [showFirstLastButtons]="false"
                [hidePageSize]="true"
                [pageSize]="PAGE_SIZE"
                [pageIndex]="page.page"
                [length]="erzeugungsanlagenPage.totalElements"
                (page)="pageChange($event)"
                >
              </mat-paginator>
            </div>
          }
        </div>
    }
  </div>
}
